/// Used to retrieve/cache/display details about a person based on their UID

import { useState } from "react";
import { Api } from "../util/Api";
import { LoadingComponent } from "./LoadingComponent";

export function UserInfoLabel(props) {
	let {
		profile,
		uid,
		field
	} = props;

	uid = uid.toString();

	if(!field) {
		field = "display";
	}

	let connections = profile.getConnections();
	let userInfo = null;
	for(const uinfo of connections) {
		if(uinfo.id.toString() == uid) {
			userInfo = uinfo;
		}
	}
	if(userInfo == null) {
		return uid; // Couldn't find user - just report their UID
	}

	return <span>
		{userInfo[field]}
	</span>;
}